// @flow
import { createBulkCnActions } from './bulkCnUsingExcelActionCreator';

const initialState = {
  isLoading: false,
  isLoaded: false,
  userType: '',
  organisationDetailsList: [],
  clientList: [],
  dashBoardData: [],
  showTableLoader: false
};

const bulkCnUsingExcelReducer = (
  state: Object = initialState,
  action: Object
) => {
  switch (action.type) {
    case createBulkCnActions.CREATE_BULK_CN: {
      return Object.assign({}, state, action.payload);
    }
    case createBulkCnActions.ADD_USER_TYPE: {
      return Object.assign({}, state, action.payload);
    }
    case createBulkCnActions.ADD_ORGANISATION_DETAILS_LIST: {
      return Object.assign({}, state, action.payload);
    }
    case createBulkCnActions.ADD_ORGANISATION_CODE_FOR_BF_USER: {
      return Object.assign({}, state, action.payload);
    }
    case createBulkCnActions.ADD_TEMPLATE_LIST_USING_ORGANISATION_CODE: {
      return Object.assign({}, state, action.payload);
    }
    case createBulkCnActions.ADD_LOCATION_LIST_USING_ORGANISATION_ID: {
      return Object.assign({}, state, action.payload);
    }

    default:
      return state;
  }
};

export default bulkCnUsingExcelReducer;
